import styled from 'styled-components';

export const Container = styled.div`
  color: #1b2a20;
  /* a foto subiu para a Capa: o bloco fica branco, com texto escuro */
  background-color: #fff;
  padding-bottom: 13.688rem;
  padding-top: 5rem;
`;

export const ContentBannersBox = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: 44.813rem;

  p,
  h5 {
    margin-bottom: 1.25rem;
    font-size: 1rem;
  }
  img {
    /* o logo da marca parceira é branco: no fundo branco, fica escuro */
    filter: brightness(0) opacity(0.85);
    display: block;
    margin: 0.75rem auto 0;
    @media only screen and (min-width: 600px) {
      display: inline;
    }
  }
`;
